import { useGetDocumentUrl } from "../api/queries/files.queries";

interface DocumentUrlParams {
	bucket: string;
	key: string;
	documentId: string;
}

export const useDocumentUrl = (
	{ bucket, key, documentId }: DocumentUrlParams,
	enabled = false,
) => {
	return useGetDocumentUrl({ bucket, key, documentId }, enabled);
};
